import { Point } from "../../maths/Point";
import { Rectangle } from "../../maths/Rectangle";
import { ClassUtils } from "../../utils/ClassUtils";
import { ColorUtils } from "../../utils/ColorUtils";
import { Pool } from "../../utils/Pool";
const className = "FillTextureCmd";
export class FillTextureCmd {
    constructor() {
        this.x = 0;
        this.y = 0;
        this.width = 1;
        this.height = 1;
        this.type = "repeat";
        this.percent = true;
        this.color = 0xffffffff;
    }
    static create(texture, x, y, width, height, type, offset, color, percent) {
        if (width == null)
            width = texture.width;
        if (height == null)
            height = texture.height;
        var cmd = Pool.getItemByClass(className, FillTextureCmd);
        cmd.texture = texture;
        texture._addReference();
        cmd.x = x;
        cmd.y = y;
        cmd.width = width;
        cmd.height = height;
        cmd.type = type;
        cmd.offset = offset;
        cmd.color = color != null ? ColorUtils.create(color).numColor : 0xffffffff;
        cmd.percent = percent;
        return cmd;
    }
    recover() {
        this.texture && this.texture._removeReference();
        this.texture = null;
        this.offset = null;
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        if (!this.texture)
            return;
        if (this.percent && runner.sprite) {
            let w = runner.sprite.width;
            let h = runner.sprite.height;
            runner.fillTexture(this.texture, this.x * w + gx, this.y * h + gy, this.width * w, this.height * h, this.type, this.offset || Point.EMPTY, this.color);
        }
        else
            runner.fillTexture(this.texture, this.x + gx, this.y + gy, this.width, this.height, this.type, this.offset || Point.EMPTY, this.color);
    }
    getBounds(assembler) {
        let rect = Rectangle.TEMP.setTo(this.x, this.y, this.width, this.height);
        if (this.percent) {
            rect.scale(assembler.width, assembler.height);
        }
        rect.getBoundPoints(assembler.points);
    }
    get cmdID() {
        return FillTextureCmd.ID;
    }
}
FillTextureCmd.ID = className;
ClassUtils.regClass(className, FillTextureCmd);
